import React, { ReactNode } from 'react';
import { Stack } from '@mui/material';
import styles from './ElementData.styles';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface ElementDataRowProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
    order?: number;
}
export default function ElementDataRow(props: ElementDataRowProps) {
    const { children, sx, order } = props;

    return (
        <Stack direction={'row'} sx={{ ...styles.row, order: order, ...(sx ?? {}) }} className={'element-data-row'}>
            {children}
        </Stack>
    );
}
